import { difference, first, uniq } from 'lodash';
import { FindTheObjectInterface, ObjectsType } from '../providers/GameProvider/types';

const getObjectsPerPage = (
  currentData: FindTheObjectInterface[],
  pageNumber: number
): ObjectsType[] => currentData?.[pageNumber]?.objects || [];

export const findObjectWithDescription = (list: ObjectsType[], description: string) =>
  list.find((objectInList) => objectInList.description.toLowerCase() === description.toLowerCase());

export const findObjectWithAnimation = (list: ObjectsType[], description: string) =>
  list.find(
    (objectInList) =>
      objectInList.description.toLowerCase() === description.toLowerCase() && objectInList.animation
  );

export const getAllObjects = (currentData: FindTheObjectInterface[]): ObjectsType[] => {
  const objectsWithOccurences: ObjectsType[] = [];

  getObjectsPerPage(currentData, 0).forEach((object) => {
    const sameObjectInNextPage = findObjectWithDescription(
      getObjectsPerPage(currentData, 1),
      object.description
    );

    objectsWithOccurences.push({
      ...object,
      animation: object.animation || sameObjectInNextPage?.animation || false,
      occurrences: object.occurrences + (sameObjectInNextPage?.occurrences || 0),
    });
  });

  getObjectsPerPage(currentData, 1).forEach((object) => {
    const objectInList = findObjectWithDescription(objectsWithOccurences, object.description);
    !objectInList && objectsWithOccurences.push({ ...object });
  });

  return objectsWithOccurences;
};

export const getObjectHint = (
  currentData: FindTheObjectInterface[],
  foundObjectsPerPage
): string | undefined =>
  first(
    difference(
      uniq(getAllObjects(currentData).map((object) => object.description)),
      foundObjectsPerPage
    )
  );
